import { Camera } from 'lucide-react';
import { useI18n } from '../i18n';
import FindPhoto from './FindPhoto';

/** A single existing photo, not a public file URL or a new identification. */
export default function FindThumbnail({ find, publicView = false }) {
    const { t } = useI18n();
    const alt = t('finds.photo_alt').replace('{name}', find?.species_name || t('finds.photo'));
    return <span data-testid={`find-thumbnail-${find?.id || 'unknown'}`} className="block shrink-0 overflow-hidden rounded-xl border border-brand-border bg-brand-bg2"
        style={{ width: 56, height: 56, flex: '0 0 56px' }}>
        <FindPhoto find={find} publicView={publicView} defer alt={alt} width={56} height={56}
            loading="lazy" decoding="async" fetchPriority="low" className="w-full h-full object-cover"
            missingLabel={t('finds.photo_missing')} failedLabel={t('finds.photo_unavailable')}
            placeholder={<Camera size={20} className="text-brand-ink3" aria-hidden="true" />} />
    </span>;
}
